var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyDataIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    stroke: "black",
    strokeOpacity: 0.501961
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.5C6.38071 6.5 7.5 5.38071 7.5 4C7.5 2.61929 6.38071 1.5 5 1.5C3.61929 1.5 2.5 2.61929 2.5 4C2.5 5.38071 3.61929 6.5 5 6.5Z",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.5H5H9.5V12.9579C9.49204 12.1957 9.29102 11.4479 8.91573 10.7845C8.54043 10.121 8.0031 9.5635 7.35393 9.16401C6.70475 8.76451 5.96491 8.53607 5.20352 8.50002C5.13564 8.49681 5.06778 8.49514 5 8.495C4.93222 8.49514 4.86436 8.49681 4.79648 8.50002C4.03509 8.53607 3.29525 8.76451 2.64607 9.16401C1.9969 9.5635 1.45957 10.121 1.08427 10.7845C0.708977 11.4479 0.507961 12.1957 0.5 12.9579V13.5Z",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.5C10.3807 6.5 11.5 5.38071 11.5 4C11.5 2.61929 10.3807 1.5 9 1.5",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.5001H13.5V12.9579C13.492 12.1957 13.291 11.4479 12.9157 10.7845C12.5404 10.121 12.0031 9.56352 11.3539 9.16403C10.9343 8.90578 10.4767 8.71902 10 8.6095",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDataIcon);
export default __webpack_public_path__ + "static/media/my_data_icon.932d971640da4b25290b454efccb37ae.svg";
export { ForwardRef as ReactComponent };